/** Maximum number of parallel per-group queries to fire. */
export const MAX_PARALLEL_GROUPS: number = 50;

/** Maximum summary queries during recursive sub-group discovery. */
export const MAX_DISCOVERY_QUERIES: number = 50;

/**
 * Distinct-value count above which a group field is treated as high-cardinality.
 * High-cardinality levels collapse by default and load lazily on expand.
 */
export const COLLAPSE_CARDINALITY_THRESHOLD: number = 25;

/**
 * Upper bound on leaf paths accumulated while walking `elementGroupSummaryTree`.
 * Beyond this the tree is treated as truncated and per-parent discovery takes over.
 */
export const MAX_GROUP_TREE_PATHS: number = 10000;

/** Row page size when loading bucket data (and when scanning for null buckets). */
export const BUCKET_PAGE_SIZE: number = 100;

/** Max unfiltered API pages to scan per null-bucket load attempt. */
export const NULL_BUCKET_MAX_SCAN_PAGES: number = 40;

/** Backend sentinel for null/blank field values in group summaries. */
export const NULL_BACKEND_SENTINEL: string = '(blank)';

/**
 * Frontend display key for null/blank field values.
 * Must match the fallback value returned by DeightonDataGridComponent.resolveGroupKey().
 */
export const NULL_DISPLAY_KEY: string = 'Unknown';

/**
 * Delimiter joining group-path segments. Must match `PATH_DELIMITER`
 * in `d-data-grid.component.ts`.
 */
export const GROUP_PATH_DELIMITER: string = '///';

/** Returns true if the value represents a null DB field (either backend or frontend sentinel). */
export function isNullSentinel(value: string): boolean {
  return value === NULL_BACKEND_SENTINEL || value === NULL_DISPLAY_KEY;
}
